import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ebb-multi-policy',
  templateUrl: './multi-policy.component.html',
  styleUrls: ['./multi-policy.component.scss']
})
export class MultiPolicyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
